// extracted by mini-css-extract-plugin
export default {"root":"Link_root__lOZET","disabled":"Link_disabled__toIaY","string":"Link_string__t0euT"};